import { useState, useCallback } from 'react';
import { getElementPosition } from '../../../utils/generic';

export const useTooltips = (tooltips) => {
  const [tooltip, setTooltip] = useState(null);
  const setTooltipCallback = useCallback((event) => {
    if (tooltips) {
      setTooltip({
        targetElement: getElementPosition(event),
        position: 'left',
        // eslint-disable-next-line no-undef
        text: tooltips[elementId],
        speed: 'm',
      });
    }
  }, [tooltips]);
  const removeTooltip = useCallback(() => {
    if (tooltips) {
      setTooltip(null);
    }
  }, [tooltips])
  return [tooltip, setTooltipCallback, removeTooltip]
}